import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2, ShieldCheck, Star, ChevronDown, BarChart3, Users, FileText, Video, Calendar, Zap, Crown, TrendingUp, Tag } from 'lucide-react';

// ── SHOPIFY VARIANT IDs ────────────────────────────────────────────────────
// IDs actualizados — sincronizados con los productos vigentes en Shopify
const ID_BASICO = '44112576053336';
const ID_PRO = '44112453206104';
const ID_VIP = '44112459333720';
const BASE = 'https://checkout.digitalsolvex.shop/cart';
const PLANS = [{
  id: 'basico',
  icon: BarChart3,
  badge: null,
  name: 'Control Básico',
  tagline: 'Lo esencial para no perder dinero por la inflación.',
  price: '$24.99',
  oldPrice: null,
  accentFrom: 'from-cyan-500',
  accentTo: 'to-blue-500',
  accentColor: '#22D3EE',
  borderClass: 'border-white/10 hover:border-cyan-500/40',
  btnClass: 'bg-white/10 hover:bg-white/20 text-white',
  checkColor: 'text-cyan-400',
  url: `${BASE}/${ID_BASICO}:1`,
  features: [{
    label: 'Masterkit Elite Excel — Sistema Financiero completo',
    bold: true,
    icon: BarChart3
  }, {
    label: 'Control de Inventario con Merma Automática'
  }, {
    label: 'Estructura de Costos y Precio Sugerido'
  }, {
    label: 'Proyección de Precios según Tasa BCV del día'
  }, {
    label: 'Registro de Ventas con descuento de stock'
  }, {
    label: 'Control de Caja e Ingresos/Egresos'
  }, {
    label: 'Dashboard con KPIs y Top 5 Productos'
  }, {
    label: 'Punto de Equilibrio Automático'
  }, {
    label: 'Manual de usuario paso a paso'
  }, {
    label: 'BONO: 100 Plantillas Canva Pro',
    bonus: true
  }, {
    label: 'BONO: Scripts de Ventas WhatsApp',
    bonus: true
  }],
  cta: 'Empezar con lo Básico',
  savings: null
}, {
  id: 'pro',
  icon: TrendingUp,
  badge: 'MÁS VENDIDO',
  badgeBg: 'bg-green-500',
  name: 'Control + Crecimiento',
  tagline: 'Sistema financiero avanzado para crecer y atraer más clientes.',
  price: '$47.99',
  oldPrice: '$84.99',
  accentFrom: 'from-green-500',
  accentTo: 'to-cyan-500',
  accentColor: '#22C55E',
  borderClass: 'border-green-500/50 hover:border-green-400',
  btnClass: 'bg-green-500 hover:bg-green-400 text-black font-black',
  checkColor: 'text-green-400',
  url: `${BASE}/${ID_PRO}:1`,
  features: [{
    label: 'TODO lo del Plan Básico',
    bold: true
  }, {
    label: 'Módulo de Fiados y Crédito ★ NUEVO',
    bold: true,
    icon: FileText,
    isNew: true
  }, {
    label: 'Controla lo que te deben, cuándo vence y el total pendiente por cobrar',
    sub: true
  }, {
    label: 'Módulo de Comparación de Proveedores ★ NUEVO',
    bold: true,
    icon: Users,
    isNew: true
  }, {
    label: 'Compara hasta 4 proveedores — el sistema elige el mejor precio/calidad',
    sub: true
  }, {
    label: 'Kit de 50 Reels Virales',
    bold: true,
    icon: Video
  }, {
    label: 'Guiones probados para atraer clientes a tu local con video corto',
    sub: true
  }, {
    label: 'Calendario de Contenidos 365 Días',
    bold: true,
    icon: Calendar
  }, {
    label: 'Qué publicar cada día del año con el formato y guión exacto',
    sub: true
  }, {
    label: 'Manual de usuario completo',
    bold: true
  }, {
    label: 'BONO: 100 Plantillas Canva Pro',
    bonus: true
  }, {
    label: 'BONO: Scripts de Ventas WhatsApp',
    bonus: true
  }],
  cta: 'Quiero Control + Crecimiento',
  savings: 'Ahorras $37'
}, {
  id: 'vip',
  icon: Crown,
  badge: '⭐ RECOMENDADO',
  badgeBg: 'bg-gradient-to-r from-green-400 to-cyan-400',
  name: 'Sistema Élite Completo',
  tagline: 'El sistema más completo para operar como empresa profesional.',
  price: '$74.99',
  oldPrice: '$109.99',
  accentFrom: 'from-amber-400',
  accentTo: 'to-green-400',
  accentColor: '#FACC15',
  borderClass: 'border-2 border-cyan-400',
  btnClass: 'bg-gradient-to-r from-green-500 to-cyan-500 hover:from-green-400 hover:to-cyan-400 text-black font-black',
  checkColor: 'text-yellow-400',
  url: `${BASE}/${ID_VIP}:1`,
  glowClass: 'shadow-[0_0_40px_rgba(34,197,94,0.2)]',
  features: [{
    label: 'TODO lo del Plan Control + Crecimiento',
    bold: true
  }, {
    label: 'Masterkit Elite ULTRA (13 pestañas)',
    bold: true,
    icon: Crown
  }, {
    label: 'Módulo de Empleados y Comisiones ★ NUEVO',
    bold: true,
    isNew: true
  }, {
    label: 'Hasta 15 empleados: sueldo, comisión, adelantos → total a pagar automático',
    sub: true
  }, {
    label: 'Módulo de Flujo de Caja Proyectado ★ NUEVO',
    bold: true,
    isNew: true
  }, {
    label: 'Proyecta los próximos 3 meses en 3 escenarios basado en tu historial real',
    sub: true
  }, {
    label: 'Etiquetador Pro ★ EXCLUSIVO VIP',
    bold: true,
    isNew: true,
    icon: Tag
  }, {
    label: 'Genera etiquetas de precios en PDF — cambias la tasa BCV y todo se actualiza solo',
    sub: true
  }, {
    label: 'Sistema de Cotizaciones Profesionales ★ EXCLUSIVO',
    bold: true,
    isNew: true,
    icon: FileText
  }, {
    label: 'Presupuestos formales en $ y Bs, listos para imprimir o enviar como PDF',
    sub: true
  }, {
    label: 'Manuales completos de todas las herramientas (3 manuales incluidos)',
    bold: true
  }, {
    label: 'Kit de 50 Reels Virales',
    bold: true,
    icon: Video
  }, {
    label: 'Calendario de Contenidos 365 Días',
    bold: true,
    icon: Calendar
  }, {
    label: 'BONO: 100 Plantillas Canva Pro',
    bonus: true
  }, {
    label: 'BONO: Scripts de Ventas WhatsApp',
    bonus: true
  }],
  cta: '¡Quiero el Sistema Élite Completo!',
  savings: 'Ahorras $35'
}];
function FeatureItem({
  feat,
  checkColor
}: {
  feat: any;
  checkColor: string;
}) {
  if (feat.sub) {
    return <li className="flex items-start gap-1.5 pl-6 -mt-1" data-id="element-174">
        <span className="text-white/30 text-xs mt-0.5 shrink-0" data-id="element-175">└</span>
        <span className="text-gray-500 text-xs leading-relaxed" data-id="element-176">{feat.label}</span>
      </li>;
  }
  if (feat.bonus) {
    return <li className="flex items-start gap-2" data-id="element-177">
        <Zap className="w-4 h-4 text-amber-400 shrink-0 mt-0.5" data-id="element-178" />
        <span className="text-amber-300/80 text-sm" data-id="element-179">{feat.label}</span>
      </li>;
  }
  return <li className="flex items-start gap-2" data-id="element-180">
      <CheckCircle2 className={`w-4 h-4 ${checkColor} shrink-0 mt-0.5`} data-id="element-181" />
      <span className={`text-sm ${feat.bold ? 'text-white font-semibold' : 'text-gray-300'}`} data-id="element-182">
        {feat.label}
        {feat.isNew && <span className="ml-1.5 text-[10px] font-black text-black bg-green-400 px-1.5 py-0.5 rounded-full uppercase tracking-wide" data-id="element-183">
            NUEVO
          </span>}
      </span>
    </li>;
}
export function OfferStack() {
  const [expanded, setExpanded] = useState<string | null>(null);
  return <section id="comprar" className="py-16 md:py-24 px-4 md:px-6 lg:px-8 max-w-7xl mx-auto overflow-hidden w-full relative z-20" data-id="element-184">
      <div className="absolute inset-0 bg-gradient-to-r from-cyan-500/5 to-green-500/5 rounded-[40px] blur-[120px] pointer-events-none" data-id="element-185" />

      <div className="relative" data-id="element-186">
        {/* Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-14" data-id="element-187">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-cyan-500/10 border border-cyan-500/20 text-cyan-400 text-xs font-bold mb-5 uppercase tracking-widest" data-id="element-188">
            <Zap className="w-3.5 h-3.5" data-id="element-189" /> Elige tu nivel de control
          </div>
          <h2 className="font-heading text-3xl md:text-5xl font-black text-white mb-4 tracking-tight" data-id="element-190">
            Un sistema para cada{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-green-400" data-id="element-191">
              etapa de tu negocio
            </span>
          </h2>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto" data-id="element-192">
            Pago único. Sin mensualidades. El archivo es tuyo de por vida.
          </p>
        </motion.div>

        {/* Cards */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 lg:gap-5 items-start" data-id="element-193">
          {PLANS.map((plan, i) => {
          const Icon = plan.icon;
          const isExpanded = expanded === plan.id;
          const isVip = plan.id === 'vip';
          return <motion.div key={plan.id} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: i * 0.1
          }} className={`relative flex flex-col rounded-3xl border transition-all duration-300
                  ${isVip ? 'bg-gradient-to-b from-green-500/8 to-cyan-500/8' : 'bg-[#0a0a0a]'}
                  ${plan.borderClass}
                  ${plan.glowClass || ''}
                `} data-id="element-194">
                {plan.badge && <div className={`absolute -top-4 left-1/2 -translate-x-1/2 ${plan.badgeBg} text-black text-xs font-black uppercase tracking-widest py-1.5 px-5 rounded-full shadow-lg whitespace-nowrap`} data-id="element-195">
                    {plan.badge}
                  </div>}

                <div className="p-6 md:p-7 flex flex-col h-full" data-id="element-196">
                  {/* Icon + Name */}
                  <div className="flex items-center gap-3 mb-3 mt-2" data-id="element-197">
                    <div className={`w-10 h-10 rounded-xl bg-gradient-to-br ${plan.accentFrom} ${plan.accentTo} flex items-center justify-center flex-shrink-0`} data-id="element-198">
                      <Icon className="w-5 h-5 text-black" data-id="element-199" />
                    </div>
                    <div data-id="element-200">
                      <p className="text-xs text-gray-500 uppercase tracking-widest font-bold" data-id="element-201">Plan</p>
                      <h3 className="text-base font-black text-white leading-tight" data-id="element-202">{plan.name}</h3>
                    </div>
                  </div>

                  <p className="text-gray-400 text-sm mb-5 leading-relaxed min-h-[40px]" data-id="element-203">{plan.tagline}</p>

                  {/* Price */}
                  <div className="flex items-baseline gap-2 mb-1" data-id="element-204">
                    <span className="text-4xl md:text-5xl font-black text-white" data-id="element-205">{plan.price}</span>
                    {plan.oldPrice && <span className="text-gray-600 text-base line-through" data-id="element-206">{plan.oldPrice}</span>}
                  </div>
                  {plan.savings && <p className="text-yellow-400 text-xs font-bold mb-4" data-id="element-207">
                      {plan.savings} vs comprar todo por separado
                    </p>}
                  {!plan.savings && <div className="mb-4" data-id="element-208" />}

                  {/* CTA */}
                  <a href={plan.url} className={`w-full py-3.5 px-4 rounded-xl text-center text-sm transition-all duration-200 mb-6 block ${plan.btnClass}`} data-id="element-209">
                    {plan.cta}
                  </a>

                  {/* Features */}
                  <ul className="space-y-2.5 flex-1" data-id="element-210">
                    {plan.features.slice(0, 6).map((feat, fi) => <FeatureItem key={fi} feat={feat} checkColor={plan.checkColor} data-id="element-211" />)}
                  </ul>

                  {plan.features.length > 6 && <>
                      <AnimatePresence initial={false} data-id="element-212">
                        {isExpanded && <motion.ul initial={{
                    height: 0,
                    opacity: 0
                  }} animate={{
                    height: 'auto',
                    opacity: 1
                  }} exit={{
                    height: 0,
                    opacity: 0
                  }} transition={{
                    duration: 0.3
                  }} className="space-y-2.5 overflow-hidden mt-2.5" data-id="element-213">
                            {plan.features.slice(6).map((feat, fi) => <FeatureItem key={fi} feat={feat} checkColor={plan.checkColor} data-id="element-214" />)}
                          </motion.ul>}
                      </AnimatePresence>

                      <button onClick={() => setExpanded(isExpanded ? null : plan.id)} className="mt-4 flex items-center gap-1.5 text-xs font-semibold text-gray-500 hover:text-gray-300 transition-colors mx-auto" data-id="element-215">
                        {isExpanded ? 'Ver menos' : `Ver todo incluido (${plan.features.length} ítems)`}
                        <motion.div animate={{
                    rotate: isExpanded ? 180 : 0
                  }} transition={{
                    duration: 0.2
                  }} data-id="element-216">
                          <ChevronDown className="w-3.5 h-3.5" data-id="element-217" />
                        </motion.div>
                      </button>
                    </>}
                </div>
              </motion.div>;
        })}
        </div>

        {/* Trust badges */}
        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="mt-12 flex flex-wrap justify-center gap-6 md:gap-10 text-gray-600 text-xs font-bold uppercase tracking-widest border-t border-white/5 pt-10" data-id="element-218">
          <span className="flex items-center gap-2" data-id="element-219">
            <ShieldCheck className="w-4 h-4 text-green-500" data-id="element-220" /> Pago Seguro
          </span>
          <span className="flex items-center gap-2" data-id="element-221">
            <Zap className="w-4 h-4 text-cyan-500" data-id="element-222" /> Entrega Inmediata
          </span>
          <span className="flex items-center gap-2" data-id="element-223">
            <Star className="w-4 h-4 text-amber-500" data-id="element-224" /> Pago Único de por vida
          </span>
          <span data-id="element-225">Pago Móvil · Binance · Tarjetas</span>
        </motion.div>
      </div>
    </section>;
}